import type { SVGProps } from "react";
export default function SvgDocumentValidationApp(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 170 190"
			{...props}
		>
			<foreignObject width={143.423} height={194} x={0} y={-4}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1094_1413_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_ddddi_1094_1413)">
				<path
					fill="url(#paint0_linear_1094_1413)"
					fillOpacity={0.6}
					d="M98.023 14H45.4C42.418 14 40 16.408 40 19.38v75.24c0 2.972 2.418 5.38 5.4 5.38h52.623c2.982 0 5.4-2.408 5.4-5.38V19.38c0-2.972-2.418-5.38-5.4-5.38"
				/>
				<path
					stroke="url(#paint1_linear_1094_1413)"
					d="M45.4 14.5h52.622c2.709 0 4.902 2.187 4.902 4.88v75.24c0 2.693-2.193 4.88-4.902 4.88H45.4c-2.708 0-4.9-2.187-4.9-4.88V19.38c0-2.693 2.192-4.88 4.9-4.88Z"
				/>
			</g>
			<path
				stroke="#FAFF00"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M54.826 86.18q5.454-5.453 5.454-8.726c0-3.272-1.09-3.272-2.181-3.272s-2.217 1.183-2.182 3.272c.037 2.234 1.808 5.32 2.727 6.545 1.636 2.182 2.727 2.727 3.818 1.09l2.181-3.272q.545 4.364 3.273 4.364c.578 0 2.878-2.182 3.272-2.182q.846 0 3.273 2.182"
			/>
			<path
				fill="#FAFF00"
				d="M89.841 41.136H53.543a2.29 2.29 0 0 1-2.294-2.284 2.29 2.29 0 0 1 2.293-2.285h36.3a2.29 2.29 0 0 1 2.293 2.285 2.29 2.29 0 0 1-2.294 2.284"
			/>
			<path
				fill="#FAFF00"
				d="M89.841 55.383H53.543a2.29 2.29 0 0 1-2.294-2.284 2.29 2.29 0 0 1 2.293-2.284h36.3a2.29 2.29 0 0 1 2.293 2.284 2.29 2.29 0 0 1-2.294 2.284"
			/>
			<foreignObject width={146.447} height={155.358} x={23.5225} y={9.86914}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1094_1413_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter1_ddddi_1094_1413)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M122.488 29.567a4.09 4.09 0 1 1 5.784 5.785L90.094 73.53a4.09 4.09 0 0 1-5.785 0L65.22 54.44a4.092 4.092 0 0 1 5.784-5.786L87.2 64.851z"
				/>
				<path
					stroke="url(#paint2_linear_1094_1413)"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeOpacity={0.5}
					d="M122.488 29.567a4.09 4.09 0 1 1 5.784 5.785L90.094 73.53a4.09 4.09 0 0 1-5.785 0L65.22 54.44a4.092 4.092 0 0 1 5.784-5.786L87.2 64.851z"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_1094_1413"
					x1={71.8734}
					x2={71.8734}
					y1={14}
					y2={100}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1094_1413"
					x1={71.7117}
					x2={33.9827}
					y1={14.9418}
					y2={76.7761}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1094_1413"
					x1={96.7461}
					x2={96.7461}
					y1={28.3691}
					y2={74.7275}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1094_1413_clip_path" transform="translate(0 4)">
					<path d="M98.023 14H45.4C42.418 14 40 16.408 40 19.38v75.24c0 2.972 2.418 5.38 5.4 5.38h52.623c2.982 0 5.4-2.408 5.4-5.38V19.38c0-2.972-2.418-5.38-5.4-5.38" />
				</clipPath>
				<clipPath id="bgblur_1_1094_1413_clip_path" transform="translate(-23.523 -9.87)">
					<path d="M122.488 29.567a4.09 4.09 0 1 1 5.784 5.785L90.094 73.53a4.09 4.09 0 0 1-5.785 0L65.22 54.44a4.092 4.092 0 0 1 5.784-5.786L87.2 64.851z" />
				</clipPath>
				<filter
					id="filter0_ddddi_1094_1413"
					width={143.423}
					height={194}
					x={0}
					y={-4}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1094_1413" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1094_1413"
						result="effect2_dropShadow_1094_1413"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1094_1413"
						result="effect3_dropShadow_1094_1413"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1094_1413"
						result="effect4_dropShadow_1094_1413"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1094_1413" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1094_1413" />
				</filter>
				<filter
					id="filter1_ddddi_1094_1413"
					width={146.447}
					height={155.358}
					x={23.5225}
					y={9.86914}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1094_1413" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1094_1413"
						result="effect2_dropShadow_1094_1413"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1094_1413"
						result="effect3_dropShadow_1094_1413"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1094_1413"
						result="effect4_dropShadow_1094_1413"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1094_1413" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1094_1413" />
				</filter>
			</defs>
		</svg>
	);
}
